export default __webpack_public_path__ + "static/media/Mordec Hammer.58a33e25.jpg";